import React from 'react';
import { Wrapper, Dot } from './dots-loader.styled';

export const DotsLoader = React.memo(() => {
  return (
    <Wrapper>
      <Dot />
      <Dot />
      <Dot />
    </Wrapper>
  );
});
